import {
  ActionCreatorWithPayload,
  createAction,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { QrAccountRecoveryState } from 'src/app/types';
import {
  RequestOptCodeActionPayload,
  SubmitOtpCodeActionPayload,
  ResetPasswordActionPayload,
} from 'src/v2/boundary/actionPayload/accountRecovery';

export const requestOptCode: ActionCreatorWithPayload<RequestOptCodeActionPayload> = createAction(
  'qrCodeAccountRecovery/requestOptCode',
);

export const submitOtpCode: ActionCreatorWithPayload<SubmitOtpCodeActionPayload> = createAction(
  'qrCodeAccountRecovery/submitOtpCode',
);

export const resetPasswordAsync: ActionCreatorWithPayload<ResetPasswordActionPayload> =
  createAction('qrCodeAccountRecovery/resetPasswordAsync');

const initialState: QrAccountRecoveryState = { message: '' };

const qrCodeAccountRecovery = createSlice({
  name: 'qrCodeAccountRecovery',
  initialState,
  reducers: {
    setMessage: (store, action: PayloadAction<string>) => {
      store.message = action.payload;
    },
  },
});

export const qrCodeAccountRecoveryReducer = qrCodeAccountRecovery.reducer;
export const { setMessage } = qrCodeAccountRecovery.actions;
